<template>
  <v-container>
    <StakeholderFilterOptions />
    <v-data-table
      :headers="headers"
      :items="filteredItems"
      :items-per-page="itemsPerPage"
      :footer-props="{
        'items-per-page-options': [1, 5, 10, 15, -1]
      }"
      :expanded.sync="expanded"
      show-expand
      item-key="pk"
      :loading="loading"
      @click:row="expandRow"
    >
      <template v-slot:item.attached_files="{ item }">
        <v-btn
          outlined
          @click="showStakeholderFilesComponent = !showStakeholderFilesComponent; selectedStakeholder = item"
        >
          Manage Files
        </v-btn>
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length">
          <v-container
            v-if="stakeholderResponses.length !== 0"
            fluid
            grid-list-md
          >
            <!-- responses component for making data iterator -->
            <StakeholderResponses
              :responses="stakeholderResponses"
              :valid-email="validEmail(item.pk)"
            />
          </v-container>
          <v-container v-else>
            <v-alert
              :value="true"
              color="info"
              icon="info"
            >
              This stakeholder has not responded to any surveys.
            </v-alert>
          </v-container>
        </td>
      </template>
      <template v-slot:no-data>
        <template v-if="showLoadingMessage">
          <!-- eslint-disable -->
          <v-alert :value="true" type="info" icon="info" class="multi-line">
            Fetching stakeholder list. If this is taking longer than usual, please ensure your internet connection is active.
          </v-alert>
          <!-- eslint-enable -->
        </template>
      </template>
    </v-data-table>
    <v-container :class="{ 'spacing-for-components': $vuetify.breakpoint.xs }">
      <StakeholderFiles
        :stakeholder="selectedStakeholder"
        :stakeholder-files="stakeholderFiles"
        :show-stakeholder-files-component="showStakeholderFilesComponent"
        @show-stakeholder-files-component-action="toggleStakeholderFilesComponent"
      />
      <v-container :class="{'spacing-for-components': $vuetify.breakpoint.xs}">
        <!-- Export Stakeholders Component -->
        <ExportStakeholders
          :filtered-items="filteredItems"
          :show-loading-message="showLoadingMessage"
        />
        <!-- Add EmailStakeholders Component -->
        <EmailStakeholders />
      </v-container>
    </v-container>
  </v-container>
</template>

<script>
import EmailStakeholders from './EmailStakeholders'
import StakeholderResponses from './StakeholderResponses'
import StakeholderFilterOptions from './StakeholderFilterOptions'
import ExportStakeholders from './ExportStakeholders'
import StakeholderFiles from './StakeholderFiles'

import { mapState, mapActions } from "vuex";
export default {
  name: "StakeholderList",
  components: {
    EmailStakeholders,
    StakeholderResponses,
    StakeholderFilterOptions,
    ExportStakeholders,
    StakeholderFiles
  },
  data: function() {
    return {
      showStakeholderFilesComponent: false,
      loading: true,
      showLoadingMessage: true,
      selectedStakeholder: {},
      headers: [
        { text: "First Name", value: "first_name" },
        { text: "Last Name", value: "last_name" },
        { text: "Email", value: "email" },
        { text: "Phone", value: "phone" },
        { text: "City", value: "city" },
        { text: "State", value: "state" },
        { text: "Zip Code", value: "postal_code" },
        { text: "Attached Files", value: "attached_files" }
      ],
      expanded: []
    };
  },
  computed: {
    ...mapState({
      stakeholderResponses: state => state.response.stakeholderResponses,
      stakeholders: state => state.stakeholders.stakeholders,
      filteredStakeholders: state => state.stakeholderList.filteredStakeholders,
      stakeholderFiles: state => state.stakeholderFiles.stakeholderFiles
    }),
    filteredItems() {
      this.toggleLoading();
      return this.filteredStakeholders;
    },
    itemsPerPage() {
      return this.$vuetify.breakpoint.xs ? 1 : 10;
    }
  },
  beforeMount() {
    this.getResponses();
    this.getPrograms();
    this.getProjects();
    this.fetchSurveys();
    this.fetchStakeholdersList();
    this.fetchStakeholders();
    this.fetchConversationsWithObjects();
    this.getStakeholderFiles();
  },
  methods: {
    ...mapActions({
      getPrograms: "programs/getPrograms",
      getProjects: "projects/getProjects",
      fetchSurveys: "survey/fetchSurveys",
      getResponses: "response/getResponses",
      fetchStakeholdersList: "stakeholderList/fetchStakeholders",
      fetchStakeholders: "stakeholders/fetchStakeholders",
      fetchConversationsWithObjects:
        "conversations/fetchConversationsWithObjects",
      addStakeholderResponses: "response/addStakeholderResponses",
      filterProjects: "projects/filterProjects",
      filterSurveys: "survey/filterSurveys",
      getStakeholderFiles: "stakeholderFiles/getStakeholderFiles"
    }),
    toggleStakeholderFilesComponent(toggle) {
      this.showStakeholderFilesComponent = toggle;
    },
    expandRow(value) {
      this.getStakeholderResponses(value.pk);
      this.expanded = value === this.expanded[0] ? [] : [value];
    },
    getStakeholderResponses(pk) {
      this.addStakeholderResponses({ pk: pk });
    },
    validEmail(stakeholderPk) {
      return (
        this.stakeholders.find(stakeholder => stakeholder.pk === stakeholderPk)
          .email === null
      );
    },
    toggleLoading() {
      this.loading = false;
      this.showLoadingMessage = false;
    }
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.multi-line {
  white-space: pre-line;
}
.formatting {
  margin: 1%;
}
.scrollable {
  /* height: 300px; */
  overflow-y: auto;
}
.conversation-bar {
  padding-left: 5% !important;
  padding-right: 5%;
}
.spacing-for-components > * {
  margin: 20px 0;
}
</style>
